// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ySDST","comment":"styles_comment__2Cmlo"};